import APIService from 'services/APIService'

const api = APIService()

export const fetchNextSteps = mode => api.get('/me/next-steps', { params: mode ? { mode } : {} })
